@if (src) {
  <div class="promotion-card">
    @if (src === 'google') {
      <div class="google-promotion">
        <div class="as-seen-google">
          <div class="inner-wrap">
            <div class="title">As Shown on Google</div>
            <div class="google-img-wrap">
              <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/google-icon.webp'" alt="google"
                   width="100" height="100" loading="lazy">
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
